module.exports = __webpack_public_path__ + "assets/img/A5-4.f71c8724.jpg";